import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { apiClient } from '@boothiva/api-client';
import '@boothiva/ui/styles';
import './styles/app.scss';
import { Providers } from './providers';
import { router } from './router';
apiClient.configure({ origin: window.location.origin, portal: 'admin' });
createRoot(document.getElementById('root')!).render(<StrictMode><Providers router={router} /></StrictMode>);
